var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/social/heart.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"c-ugc-pdp__heart-svg\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0\" y=\"0\" viewBox=\"-339 -8 87.8 80\" xml:space=\"preserve\" enable-background=\"new -339 -8 87.8 80\" class=\"i-heart\">\n  <title>";
output += runtime.suppressValue((lineno = 1, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_ugc-heart-svg-title"])), env.opts.autoescape);
output += "</title>\n  <path d=\"M-261.3-5.4c-17.5-10.8-33.8 15.7-33.8 15.7s-16.3-26.5-33.7-15.7c-19.5 12.1-6.9 37.2 4.3 48.4 21.4 21.4 29.4 29 29.4 29s8-7.7 29.4-29.1C-254.5 31.8-241.8 6.6-261.3-5.4z\"></path>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/social/heart.j2"] , dependencies)